import { render, staticRenderFns } from "./DogInfo.vue?vue&type=template&id=15fddcc5"
import script from "./DogInfo.vue?vue&type=script&lang=ts"
export * from "./DogInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports